import classname from 'classnames';
import { PhotoMediaFallback } from 'components/Photo/PhotoMediaFallback';
import { PhotoTypeFallback } from 'components/Photo/PhotoTypeFallback';
import * as React from 'react';

import './Photo.scss';

type PhotoSrcType = string | { default: string, webp?: string }

export interface PhotoSrcProps {
  src: PhotoSrcType;
  srcWebp?: PhotoSrcType;
  src768?: PhotoSrcType;
  src1024?: PhotoSrcType;
  src1280?: PhotoSrcType;
  src1600?: PhotoSrcType;
  src1920?: PhotoSrcType;
  firstName?: string;
  lastName?: string;
  alt?: string;
  blurMobile?: boolean;
}

interface PhotoProps extends PhotoSrcProps {
  alt: string;
  backgroundImage?: boolean;
  vignet?: boolean;
  retina?: boolean;
}

const Photo: React.FC<PhotoProps> = props => {
  const className = classname(
    'srprs-photo',
    props.vignet || (props.firstName && props.lastName) ? 'type-vignet' : '',
    props.retina ? 'retina' : '',
    props.blurMobile ? `blur-mobile` : ``,
  );
  return (
    <figure className={className}>
      <picture>
        {/*TODO: remove "background-image support (done by that "i" below) since we can use object-fit <3 */}
        {props.backgroundImage ? (
            <PhotoTypeFallback src={props.src} alt={props.alt} />
          )
          : (
            <>
              <PhotoMediaFallback src={props.src1920} minWidth={1920} />
              <PhotoMediaFallback src={props.src1600} minWidth={1600} />
              <PhotoMediaFallback src={props.src1280} minWidth={1280} />
              <PhotoMediaFallback src={props.src1024} minWidth={1024} />
              <PhotoMediaFallback src={props.src768} minWidth={768} />
              <PhotoTypeFallback src={props.src} alt={props.alt} />
            </>
          )}

        {props.firstName && props.lastName && (
          <figcaption>
            {props.firstName}
            <br />
            <span className="dot" />
            {props.lastName}
          </figcaption>
        )}
      </picture>
    </figure>
  );
};

export default Photo;
